import React, { Component } from 'react';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';

import { getTestAttributes } from '@common/utils/tests';
import { Flex } from '@common/components/Flex';
import Tree from '@common/components/Tree';
import { FormControl } from '@common/components/form-control';
import { Button } from '@common/components/Button';

import './folder-creating.styles.scss';

const MODULE_NAME = 'FOLDER_CREATING';

export class FolderCreating extends Component {
    static propTypes = {
        folders: PropTypes.array,
        close: PropTypes.func.isRequired,
    };

    static defaultProps = {
        folders: [],
    };

    state = {
        selectedFolderId: null,
        folderName: '',
    };

    handleFolderChange = (id) => {
        if (id === this.state.selectedFolderId) {
            return;
        }

        this.setState((state) => ({
            ...state,
            selectedFolderId: id,
        }));
    }

    handleSubmitSubmit = () => {
        const { onSubmit } = this.props;
        const { selectedFolderId, folderName } = this.state;

        onSubmit({ parentId: selectedFolderId, name: folderName });
    }

    handleFolderNameChange = (e) => {
        e.persist();
        this.setState((x) => ({ ...x, folderName: e.target.value }));
    }

    render() {
        const { folders, close } = this.props;
        const { selectedFolderId, folderName } = this.state;

        return (
            <Modal 
                show
                bsSize="small"
                backdrop="static"
                bsClass="bootstrap modal"
                className="FolderCreating"
                dialogClassName="FolderCreating__dialog"
                animation={false}
                onEscapeKeyDown={close}
                onHide={close}
            >
                <ModalHeader closeButton onHide={close} className="FolderCreating__dialog__header">
                    <ModalTitle {...getTestAttributes(MODULE_NAME, 'modal', 'title')}>{I18n.t('Add Format Folder')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="FolderCreating__content">
                        <Flex className="FolderCreating__content__folder-name" alignItems="center">
                            <span className="FolderCreating__content__folder-name__label">{I18n.t('Folder Name')}</span>
                            <FormControl 
                                {...getTestAttributes(MODULE_NAME, 'folder-name', 'input')} 
                                className="FolderCreating__content__folder-name__input" 
                                value={folderName} 
                                onChange={this.handleFolderNameChange} 
                            />
                        </Flex>
                        <Tree
                            className="FolderCreating__content__folders"
                            items={folders}
                            value={selectedFolderId} 
                            onChange={this.handleFolderChange} 
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button {...getTestAttributes(MODULE_NAME, 'cancel', 'btn')} onClick={close}>{I18n.t('Cancel')}</Button>
                    <Button {...getTestAttributes(MODULE_NAME, 'submit', 'btn')} disabled={!folderName} className="btn-primary" onClick={this.handleSubmitSubmit}>{I18n.t('Save')}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}